module.exports = __webpack_public_path__ + "img/sticker_20.199425ba.svg";